import app from "../main";
import objectHelper from "./object_helper";

const notifyHelper = {
    error: function (message, options = {}) {
        this.show(message, 'error', options);
    },
    success: function (message, options = {}) {
        this.show(message, 'success', options);
    },
    warning: function (message, options = {}) {
        this.show(message, 'warn', options);
    },
    info: function (message, options = {}) {
        this.show(message, 'info', options);
    },
    show: (message, type, options = {}) =>
        app.$notify(objectHelper.mergeTo(options, {
            group: 'app-notify',
            type: type,
            title: app.$t('Notify title'),
            duration: 3000,
            text: app.$t(message)
        }))
}

export default notifyHelper;